import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const JSM_QUEUE_SETTINGS_CLIENT_ID: ClientId = client('jsm-queue-settings');
